(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // --- AJAX ADD TO CART & ANIMATION TRIGGER ---
  document.addEventListener('click', function(e) {
    // Looks for standard theme selectors or custom hover buttons inside product items
    const addToCartBtn = e.target.closest('.hover-add-to-cart, [data-add-to-cart], .product-grid__item button[type="submit"]');
    if (!addToCartBtn) return;

    // If it's a standard form button, prevent the default page refresh redirect
    e.preventDefault();
    
    // Attempt to dynamically find the variant ID from the button or closest form elements
    let variantId = addToCartBtn.getAttribute('data-variant-id');
    if (!variantId) {
      const form = addToCartBtn.closest('form');
      if (form) {
        const variantInput = form.querySelector('[name="id"]');
        if (variantInput) variantId = variantInput.value;
      }
    }
    
    // Fallback: If no explicit variant is found, try looking for the parent grid item's data attributes
    if (!variantId) {
      const gridItem = addToCartBtn.closest('.product-grid__item');
      if (gridItem) variantId = gridItem.getAttribute('data-product-id'); 
    }

    if (!variantId) return;

    // Visual Feedback: Loading State
    const originalText = addToCartBtn.innerHTML;
    addToCartBtn.innerHTML = 'Adding...';
    addToCartBtn.disabled = true;

    // 1. Post to Shopify's Cart AJAX API
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      // Reset button state
      addToCartBtn.innerHTML = originalText;
      addToCartBtn.disabled = false;

      // 2. Fire Global Theme Triggers to open Cart Drawers / Flyouts automatically
      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: data }
      }));
      
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        bubbles: true,
        detail: { product: data }
      }));

      // Shopify Web Component compatibility (Dawn & similar modern OS2.0/3.0 themes)
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification && typeof cartNotification.renderContents === 'function') {
        cartNotification.renderContents(data);
      } else if (cartNotification && typeof cartNotification.open === 'function') {
        cartNotification.open();
      }
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
      addToCartBtn.innerHTML = originalText;
      addToCartBtn.disabled = false;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
